var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "cookie-consent-modal",
        size: "lg",
        centered: "",
        title: _vm.$t("CookieConsent.Header"),
        "no-close-on-esc": true,
        "no-close-on-backdrop": true,
        "hide-header-close": true
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function() {
            return [
              _c(
                "h2",
                {
                  staticClass: "modal-title",
                  attrs: { id: "cookie-consent-modal___BV_modal_title_" }
                },
                [_vm._v(_vm._s(_vm.$t("CookieConsent.Header")))]
              ),
              _vm._v(" "),
              _c("language-selection")
            ]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c("div", { staticClass: "w-100 centered" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-all",
                    attrs: { type: "button" },
                    on: { click: _vm.consentAll }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("CookieConsent.All")) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-necessary",
                    attrs: { type: "button" },
                    on: { click: _vm.consentNecessary }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("CookieConsent.Necessary")) +
                        "\n      "
                    )
                  ]
                )
              ])
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _vm._v(" "),
      _c("p", { staticClass: "consent-dialog-message" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("CookieConsent.Message")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-toggle",
              rawName: "v-b-toggle.info-collapse",
              modifiers: { "info-collapse": true }
            }
          ],
          staticClass: "mt-2 left",
          attrs: { variant: "consent-info", size: "sm" }
        },
        [_vm._v(_vm._s(_vm.$t("CookieConsent.LinkLabel")))]
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        { staticClass: "mt-2", attrs: { id: "info-collapse" } },
        [_c("cookie-consent-info")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }